import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthenticated } from "../system/redux/reducers/userStateReducer";
import { setUserInfo } from "../system/redux/reducers/roleReducer";
import { setMenuInfo } from "../system/redux/reducers/menuReducer";
import { setCSRFInfo } from "../system/redux/reducers/csrfReducer";
import API_Routes from "../../constants/api-routes";
import { setCCEmailReducer } from "../system/redux/reducers/CCEmailReducer";
import { setResponsePendingReducer } from "../system/redux/reducers/ResponsePendingReducer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { applicationContextRoot } from "../../constants/constants";
import { setReloadFeedbackDetails } from "../system/redux/reducers/reloadFeedbackDetails";
import { setNavigationData } from "../system/redux/reducers/NavigatedDataReducer";
export function useRefreshState() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useSelector(
    (state) => state.userState
  );

  const headers = {
    Accept: "*/*",
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Credentials": true,
    "Access-control-Allow-Orogin": "*",
    redirect: "false",
  };
  const csrfValues = {
    csrfHeaderName: "X-CSRF-Token",
    csrfFormTagName: "_csrf",
    csrfToken: "",
  };

  const userData = {
    userEmail: "",
    homeLink: " ",
    roles: [],
  };

  const isAuthenticatedTemp = {
    isAuthenticated: false,
    isLoading: true,
    isCaptchaEnabled: null,
    isCaptchaForSurveyEnabled: null
  };

  const menuData = {
    menuItems: [],
  };
  const handleLogout = (e) => {
    console.log("Logout");
    const formData = csrfValues.csrfFormTagName + "=" + csrfValues.csrfToken;
    async function logout(params) {
      const response = await axios
        .post(API_Routes.logout, formData, { withCredentials: true })
        .then((res) => {
          console.log(res.status);
          if (res.status === 200) {
            dispatch(setNavigationData({}));
            fetchCSRF();
            fetchUserState();
          }
        });
    }
    logout();
    
  };
  const fetchUserState = useCallback(() => {
    console.log(
      "Fetching User State at time: " + new Date().toLocaleTimeString()
    );
    const response = axios
      .get(API_Routes.loginInfo, { withCredentials: true }, headers)
      .then((response) => {
        // debugger;
        if (response.status === 200) {
          debugger;
          isAuthenticatedTemp.isCaptchaEnabled = response.data.isCaptchaEnabled;
          isAuthenticatedTemp.isCaptchaForSurveyEnabled = response.data.isCaptchaForSurveyEnabled;
          isAuthenticatedTemp.isAuthenticated = response.data.isAuthenticated;
          isAuthenticatedTemp.isLoading = false;
          dispatch(setIsAuthenticated(isAuthenticatedTemp));
          if (response.data.isAuthenticated) {
            //debugger;
            userData.userEmail = response.data.userEmail;
            userData.homeLink = response.data.homeLink;
            userData.roles = response.data.userRoles;
            userData.userId = response.data.userId;
            userData.userName = response.data.userName;
            userData.orgName = response.data.orgName;
            userData.userCurrRole = { ...response.data.userCurrRole };
            userData.isChatEnabled=response.data.isChatEnabled;
            userData.isBotChatEnabled=response.data.isBotChatEnabled;
            userData.isAgentChatEnabled=response.data.isAgentChatEnabled;
            userData.isCallbackEnabled=response.data.isCallbackEnabled;
            userData.isFAQEnabled=response.data.isFAQEnabled;
            userData.isWorkingTime = response.data.isWorkingTime;
            userData.workingHoursList = response.data.workingHoursList;
            userData.serviceUserId = response.data.serviceUserId;
            menuData.menuItems = response.data.menus;
            dispatch(setUserInfo(userData));
            dispatch(setMenuInfo(menuData));
            dispatch(setCCEmailReducer(-10));
            dispatch(setReloadFeedbackDetails({switchToDashboardView:true}));
            dispatch(
              setResponsePendingReducer({
                assignGroupOnSubmit: false,
                acceptFeedbackOnSubmit: false,
                addFeedbackOnSubmit: false,
                closeFeedbackOnSubmit: false,
                discardFeedbackOnSubmit: false,
                assignGroupOnRecalculate: false,
              })
            );
          } else {
            if (response?.data?.homeLink) {
              userData.homeLink = response.data.homeLink;
              dispatch(setUserInfo(userData));
            }
          }
        } else {
          if (response?.data?.homeLink) {
            userData.homeLink = response.data.homeLink;
            dispatch(setUserInfo(userData));
          }
          isAuthenticatedTemp.isAuthenticated = false;
          isAuthenticatedTemp.isLoading = false;
          dispatch(setIsAuthenticated(isAuthenticatedTemp));
          dispatch(setNavigationData({}));
          handleLogout();
        }
      })
      .catch((error) => {
        console.log(error);
        handleLogout();
      });
  });

  const fetchCSRF = useCallback(async () => {
    console.log("Fetching CSRF at time: " + new Date().toLocaleTimeString());
    const csrfResponse = await axios
      .get(API_Routes.getCSRF, { withCredentials: true }, headers)
      .then((res) => {
        const contentType = res.headers["content-type"];
        // console.log("Content Type of CSRF: " + contentType);
        if (contentType?.includes("text/html")) {
          fetchCSRF();
        } else {
          csrfValues.csrfToken = res.data;
          dispatch(setCSRFInfo(csrfValues));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return csrfResponse;
  });

  useEffect(() => {
    if (!isAuthenticated) {
      fetchCSRF().then((response) => {
        fetchUserState();
      });
    }
  }, [isAuthenticated]);

  return { isAuthenticated, isLoading };
}
